import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import DNI from "../components/tramites/dni";
import Pasaporte from "../components/tramites/pasaporte";
import LocalStorageService from "../ports/localStorage/localStorageService";
import {withTranslation} from "react-i18next";
import Loading from "./Loading";
import Mantenimiento from "./Mantenimiento";
import BackendConnectionService from "../ports/backend/backendConnectionService";
import PasaporteDisabled from "../components/tramites/pasaporteDisabled";

class Home extends React.Component {

    constructor(props) {
        super(props);
        if(LocalStorageService.getTramite() == null) {
            LocalStorageService.changeTramite("dni");
        }
        this.state = {
            message: null,
            type: null,
            loading: false,
            localMaintenance: false,
            passportEnabled: true
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        BackendConnectionService.getInstanceConfiguration()
            .then(config => {
                console.log(config);
                this.setState({ loading: false, localMaintenance: config.data.maintenance, passportEnabled: config.data.passportEnabled });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    render() {
        const { loading, localMaintenance, passportEnabled } = this.state;
        if (loading) {
            return <Loading />;
        }
        if (localMaintenance) {
            return <Mantenimiento />;
        }
        return(
            <div id="layout-wrapper">
                <Navbar />
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <DNI />
                                {passportEnabled ? <Pasaporte /> : <PasaporteDisabled />}
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
            );
    }
}
export default withTranslation()(Home);
